import { addon, OptionGroup, QuantityType } from "@/types/ProductType";
import { useState } from "react";
import CashierCardModal from "./CashierCardModal";
import { AppConfig } from "@/utils/AppConfig";
import { useTranslation } from "react-i18next";
import useLockBodyScroll from "@/hooks/useLockBodyScroll";
import TablesCardModal from "./TablesCardModal";

interface CashierCardProps {
  id: string;
  imageUrl: string;
  price: number;
  lowPrice: number | undefined;
  options: OptionGroup[] | undefined;
  addons: addon[] | undefined;
  nameAR: string;
  nameEN: string;
  descriptionAR: string;
  descriptionEN: string;
  calories: number | undefined;
  maxQuantity: QuantityType;
  isTables?: boolean
}

function CashierCard({
  id,
  imageUrl,
  price,
  lowPrice,
  options,
  addons,
  nameAR,
  nameEN,
  descriptionAR,
  descriptionEN,
  calories,
  maxQuantity,
  isTables
}: CashierCardProps) {
  const { i18n } = useTranslation();
  const locale = i18n.language
  const [showModal, setShowModal] = useState(false);
  useLockBodyScroll(showModal);
  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const lowPriceOrBasePrice = lowPrice ? lowPrice : price;


  return (
    <div
      className="relative w-full h-[150px] xs:h-[130px] xs:w-[170px] lg:w-[150px] xl:w-[170px] cursor-pointer rounded-xl border bg-white p-3 overflow-hidden"
      onClick={toggleModal}
    >
      {/* Product Image (Full Cover) */}
      <img
        src={imageUrl}
        alt={locale === "en" ? nameEN : nameAR as string}
        className="absolute inset-0 w-full h-full object-cover rounded-xl"
        loading="eager"
      />

      {/* Overlay */}
      <div
        className={`absolute left-0 top-0 flex h-full w-full flex-col justify-start overflow-hidden rounded-xl bg-black bg-opacity-50 px-1 text-white text-lg lg:text-base xl:text-lg ${i18n.dir() === "rtl" ? "items-start" : "items-end"}`}
      >
        <div dir="rtl" className="w-fit rounded-md p-1  font-semibold">
          {lowPriceOrBasePrice.toLocaleString("en-EG", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}{" "}
          {AppConfig.currency.icon("currentcolor", 17)}
        </div>

        <h2 className="no-scrollbar w-full overflow-y-auto p-1 text-center  font-bold">
          {locale === "en" ? nameEN : nameAR}
        </h2>
      </div>

      {!isTables ? <CashierCardModal
        id={id}
        show={showModal}
        onClose={toggleModal}
        basePrice={+price}
        lowPrice={lowPrice}
        options={options}
        addons={addons}
        nameAR={nameAR}
        nameEN={nameEN}
        ImageUrl={imageUrl}
        descriptionAR={descriptionAR}
        descriptionEN={descriptionEN}
        calories={calories}
        maxQuantity={maxQuantity}
      /> : <TablesCardModal
        id={id}
        show={showModal}
        onClose={toggleModal}
        basePrice={+price}
        lowPrice={lowPrice}
        options={options}
        addons={addons}
        nameAR={nameAR}
        nameEN={nameEN}
        ImageUrl={imageUrl}
        descriptionAR={descriptionAR}
        descriptionEN={descriptionEN}
        calories={calories}
        maxQuantity={maxQuantity}
      />}
    </div>
  );
}

export default CashierCard;
